import { render, staticRenderFns } from "./adjust-policy-info.vue?vue&type=template&id=1b91b2e5&scoped=true&"
import script from "./adjust-policy-info.vue?vue&type=script&lang=js&"
export * from "./adjust-policy-info.vue?vue&type=script&lang=js&"
import style0 from "./adjust-policy-info.vue?vue&type=style&index=0&id=1b91b2e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b91b2e5",
  null
  
)

export default component.exports